module.exports = __webpack_public_path__ + "media/images/application/template/meganav/shipping-containers/9ft-68d5674b0881e643cd605aae3be2a0d3.png";